import React, { useState, useEffect, useRef } from 'react';
import ToolTip from 'react-portal-tooltip'
import { useHover } from 'components/common/hooks'
const Segment = (props) =>
    <line
        x1="0" x2={props.maxLength}
        y1="30" y2="30"
        stroke={props.color} strokeWidth="20" strokeOpacity="1"
        strokeDasharray={props.strokeDasharray} transform={props.x1} style={props.css}
    />
export default function Bar(props) {
    const [containerCss, setContainerCss] = useState({});
    const [lengths, setLengths] = useState([0, 0, 0]);
    const [haveTrans, setHaveTrans] = useState(false);
    const myBarRef = useRef(null)
    const [hoverRef, isHovered] = useHover();
    const maxLength = 245;
    const colors = ["rgb(235,241,222)", "rgb(196,215,155)", "rgb(79, 98, 41)"];
    useEffect(() => {
        window.addEventListener("resize", updateWidth());
        window.addEventListener("resize", setHaveTrans(false));

        // Verify values
        const values = props.values.slice();
        // values[0] = Math.max(0, Math.min( values[0], 1 ));
        // values[1] = Math.max(0, Math.min( values[1], 1-values[0] ));
        // values[2] = Math.round(Math.max(0, Math.min( 1 - (values[0] + values[1]), 1 )) * 10000) / 10000;
        //  const test = [0.553, 0.179, 0.267]
        setLengths(values);
        return () => {
            window.removeEventListener("resize", setHaveTrans(false));
            window.removeEventListener("resize", updateWidth());
        }

    }, [props.values])
    useEffect(() => {
        if (!haveTrans) {
            setHaveTrans(true);
        }
        const values = props.values.slice();
        // const test = [0.993, 0.005, 0.002]
        setLengths(values);
    }, [haveTrans, props.values])

    function updateWidth() {
        var width = myBarRef.current.offsetWidth;
        var scaleNum = (width / maxLength) * 1;
        var scale = "scale(" + scaleNum + ")";
        var height = scaleNum * 70;
        var css = {
            transformOrigin: 'left top',
            WebkitTransformOrigin: 'left top',
            transform: scale,
            WebkitTransform: scale,
            height: `${height}px`
        }
        setContainerCss(css);
    }

    function renderInfo(i) {
        // Show in middle of Segment
        var offset = -8;
        var left = 0;
        for (var n = 0; n < i; n++) {
            left += lengths[n];
            // offsetLeft -= offset;
            // offsetRight += offset;
        }
        left = offset + (left + (lengths[i] / 2)) * (maxLength);

        var css = {
            left: left
        }
        // Convert values to percent first
        var percent = Math.round(lengths[i] * 1000) / 10;
        // General display condition don't show if length is zero
        var generalDisplayCondition = `${lengths[i] < 0.001 ? "hide " : ""}`;

        var labelClassName = `bar-info__label ${haveTrans ? "bar-info_have_trans" : "bar-info_no_trans"} ${(Number(i) !== 1) ? "bar-info_top" : ""} `;
        var marker = percent + "%";
        return (
            <React.Fragment>
                <span className={`${labelClassName} ${generalDisplayCondition} `}
                    style={css}>{marker}
                </span>
            </React.Fragment>
        );
    }

    function renderSegment(i) {
        // Set x origin of segment
        var x1 = 0;
        for (var n = 0; n < i; n++) {
            x1 += lengths[n];
        }
        // Don't draw if length is zero
        const strokeColors = colors.slice();
        if (Number(lengths[i]) <= 0.001) {
            strokeColors[i] = "none";
        }
        x1 = Math.max(0, x1 * maxLength);
        var translateX = "translate(" + x1 + ")";
        // Set strokeDasharray
        var strokeDasharray = [0, maxLength];
        strokeDasharray[0] = lengths[i] * maxLength;
        strokeDasharray[1] = (1 - lengths[i]) * maxLength;
        const haveTransCss = {
            transitionProperty: "all",
            transitionDuration: "1s",
            transitionTimingFunction: "easeInOut"
        };
        return (
            <Segment
                x1={translateX}
                strokeDasharray={strokeDasharray}
                maxLength={maxLength}
                color={strokeColors[i]}
                css={haveTrans ? haveTransCss : {}}
            />

        );
    }
    return (
        <div>
            <div className="widget-card__stacked-bar" style={containerCss} ref={myBarRef}>
                <svg className="bar-svg" >
                    {renderSegment(0)}
                    {renderSegment(2)}
                    {renderSegment(1)} {/*Draw middle segment last*/}
                </svg>
                <div className="bar-info" id={"legend-tooltip" + props.id} ref={hoverRef}>
                    {renderInfo(0)}
                    {renderInfo(1)}
                    {renderInfo(2)}
                </div>
                <ToolTip active={isHovered} position="top" arrow="center"
                    parent={"#legend-tooltip" + props.id}
                    style={{
                        style: {
                            background: "rgba(0,0,0,1)",
                            padding: 10,
                            color: "#EEE",
                            boxShadow: "5px 5px 3px rgba(0,0,0,.8)",
                            borderRadius: 0,
                            transition: 'all .2s ease-in-out',
                            zIndex: 7089
                        },
                        arrowStyle: {
                            display: "none"
                        }
                    }}
                    tooltipTimeout={200}
                >
                    <div className="stacked-bar-legends">
                        <span className="stacked-bar-legends__header">Occupancy Breakdown</span>
                        <span className="stacked-bar-legends__info" >How many percent of total working time the occupancy percentage has been within the following ranges:</span>
                        <div className="stacked-bar-legends__wrapper">
                            <span>&lt;25%</span>
                            <span>25-75%</span>
                            <span> >75%</span>
                        </div>
                    </div>
                </ToolTip>
            </div >
        </div>
    );
}




// WEBPACK FOOTER //
// ./src/components/common/widgets/bar.jsx